<template>
  <form id="mainForm" action="#" method="post">
    <Card>
      <template #title>
        <Toolbar>
          <template #left>
            <div class="p-card-title">[{{ mode }}] {{ $t("user") }}</div>
            <div
              style="margin-left: 10px"
              v-if="mode != this.$FORM_MODE_CREATE"
            >
              <Button
                type="button"
                icon="pi pi-info"
                @click="toggle"
                aria:haspopup="true"
                aria-controls="overlay_panel"
                class="p-button-rounded p-button-outlined p-button-sm"
              />

              <OverlayPanel
                ref="op"
                appendTo="body"
                :showCloseIcon="true"
                id="overlay_panel"
                style="width: 550px"
                :breakpoints="{ '960px': '80vw' }"
              >
                <div class="p-grid p-field">
                  <div class="p-row">
                    <i class="pi pi-plus-circle" />
                    {{ this.$formatDateTime(header.CreatedDate) }}
                  </div>
                  <div class="p-row">by {{ header.CreatedBy }}</div>
                </div>
                <div class="p-grid p-field" v-if="header.EditedDate">
                  <div class="p-row">
                    <i class="pi pi-pencil" />
                    {{ this.$formatDateTime(header.EditedDate) }}
                  </div>
                  <div class="p-row">by {{ header.EditedBy }}</div>
                </div>
              </OverlayPanel>
            </div>
          </template>

          <template #right>
            <Button
              icon="pi pi-chevron-left"
              label="Back"
              class="p-button mr-2"
              @click="backToIndex"
            />
            <Button
              icon="pi pi-save"
              :label="$t('save')"
              class="p-button-success mr-2"
              @click="confirm($event)"
              v-if="
                mode != this.$FORM_MODE_VIEW && mode != this.$FORM_MODE_DELETE
              "
            />
            <Button
              icon="pi pi-trash"
              label="Delete"
              class="p-button-danger mr-2"
              @click="confirm($event)"
              v-if="mode == this.$FORM_MODE_DELETE"
            />
            <ConfirmPopup></ConfirmPopup>
          </template>
        </Toolbar>
      </template>
      <template #content>
        <div class="p-inputtext-sm p-fluid">
          <TabView>
            <TabPanel header="Header Groups">
              <div class="grid">
                <div class="col-6">
                  <FormField
                    :labelName="$t('emp_number')"
                    fieldName="Username"
                    v-model="header"
                    labelClass="col-4"
                    fieldClass="col-6 md-6"
                  >
                    <InputText
                      name="Username"
                      v-model="header.Username"
                      type="text"
                      v-on:blur="onBlur()"
                      :placeholder="$t('emp_number')"
                      v-if="header"
                      :disabled="!canEdit || this.isAdmin != 'Y'"
                    />
                  </FormField>

                  <FormField
                    :labelName="$t('full_name')"
                    fieldName="Fullname"
                    v-model="header"
                    labelClass="col-4"
                    fieldClass="col-6 md-6"
                  >
                    <InputText
                      name="Fullname"
                      v-model="header.Fullname"
                      type="text"
                      :placeholder="$t('full_name')"
                      v-if="header"
                      :disabled="!canEdit || this.isAdmin != 'Y'"
                    />
                  </FormField>

                  <FormField
                    :labelName="$t('email')"
                    fieldName="Email"
                    v-model="header"
                    labelClass="col-4"
                    fieldClass="col-6 md-6"
                  >
                    <InputText
                      name="Email"
                      v-model="header.Email"
                      type="text"
                      :placeholder="$t('email')"
                      v-if="header"
                      :disabled="!canEdit || this.isAdmin != 'Y'"
                    />
                  </FormField>

                  <FormField
                    :labelName="$t('phone')"
                    fieldName="Phone"
                    v-model="header"
                    labelClass="col-4"
                    fieldClass="col-6 md-6"
                  >
                    <InputText
                      name="Phone"
                      v-model="header.Phone"
                      type="text"
                      :placeholder="$t('phone')"
                      v-if="header"
                      :disabled="!canEdit || this.isAdmin != 'Y'"
                    />
                  </FormField>

                  <FormField
                    :labelName="$t('company')"
                    fieldName="CompanyCode"
                    v-model="header"
                    labelClass="col-4"
                    fieldClass="col-6 md-6"
                  >
                    <CustomSelect
                      class="p-inputtext-sm"
                      v-model="header.CompanyCode"
                      v-if="header"
                      :url="this.$API_URL + 'list/company_code'"
                      :minLength="0"
                      :params="{}"
                      :disabled="!canEdit || this.isAdmin != 'Y'"
                      :filter="true"
                      @change="changeDept($event)"
                    />
                  </FormField>

                  <FormField
                    :labelName="$t('department')"
                    fieldName="DepartmentId"
                    v-model="header"
                    labelClass="col-4"
                    fieldClass="col-6 md-6"
                  >
                    <CustomSelect
                      class="p-inputtext-sm"
                      v-model="header.DepartmentId"
                      @change="deptchange($event)"
                      v-if="header"
                      :url="this.$API_URL + 'list/department'"
                      :minLength="0"
                      :params="{ companyCode: header.CompanyCode }"
                      :filter="true"
                      :disabled="!canEdit || this.isAdmin != 'Y'"
                    />
                  </FormField>

                  <FormField
                    :labelName="$t('country')"
                    fieldName="Country"
                    v-model="header"
                    labelClass="col-4"
                    fieldClass="col-6 md-6"
                  >
                    <CustomSelect
                      class="p-inputtext-sm"
                      v-model="header.Country"
                      v-if="header"
                      :url="this.$API_URL + 'list/country_code'"
                      :minLength="0"
                      :filter="true"
                      :params="{}"
                      :disabled="!canEdit || this.isAdmin != 'Y'"
                    />
                  </FormField>

                  <FormField
                    :labelName="$t('timezone')"
                    fieldName="Timezone"
                    v-model="header"
                    labelClass="col-4"
                    fieldClass="col-6 md-6"
                  >
                    <CustomSelect
                      v-model="header.Timezone"
                      v-if="header"
                      :url="this.$API_URL + 'list/timezone'"
                      :minLength="0"
                      :filter="true"
                      :params="{}"
                      :disabled="!canEdit || this.isAdmin != 'Y'"
                    />
                  </FormField>

                  <FormField
                    :labelName="$t('use_ad')"
                    fieldName="UseAD"
                    v-model="header"
                    labelClass="col-4"
                    fieldClass="col-6 md-6"
                    v-if="this.isAdmin == 'Y'"
                  >
                    <!-- <InputText name="Email" v-model="header.Email" type="text" :placeholder="$t('email')"  v-if="header" :disabled="mode == this.$FORM_MODE_VIEW"  /> -->
                    <YNCheckbox
                      v-model="header.UseAD"
                      :disabled="!canEdit || this.isAdmin != 'Y'"
                      v-if="header"
                      :binary="true"
                    />
                  </FormField>

                  <FormField
                    :labelName="$t('is_manage')"
                    fieldName="IsManage"
                    v-model="header"
                    labelClass="col-4"
                    fieldClass="col-6 md-6"
                  >
                    <!-- <InputText name="Email" v-model="header.Email" type="text" :placeholder="$t('email')"  v-if="header" :disabled="mode == this.$FORM_MODE_VIEW"  /> -->
                    <YNCheckbox
                      v-model="header.IsManage"
                      :disabled="!canEdit"
                      v-if="header"
                      :binary="true"
                    />
                  </FormField>

                  <FormField
                    :labelName="$t('isPriv')"
                    fieldName="IsPriv"
                    v-model="header"
                    labelClass="col-4"
                    fieldClass="col-6 md-6"
                    v-if="mode != this.$FORM_MODE_CREATE"
                  >
                    <!-- <InputText name="Email" v-model="header.Email" type="text" :placeholder="$t('email')"  v-if="header" :disabled="mode == this.$FORM_MODE_VIEW"  /> -->
                    <YNCheckbox
                      v-model="header.IsPriv"
                      :disabled="!canEdit"
                      v-if="header"
                      :binary="true"
                      @click="checkdept($event)"
                    />
                  </FormField>

                  <FormField
                    :labelName="$t('is_admin')"
                    fieldName="IsAdmin"
                    v-model="header"
                    labelClass="col-4"
                    fieldClass="col-6 md-6"
                    v-if="this.isAdmin == 'Y'"
                  >
                    <!-- <InputText name="Email" v-model="header.Email" type="text" :placeholder="$t('email')"  v-if="header" :disabled="mode == this.$FORM_MODE_VIEW"  /> -->
                    <YNCheckbox
                      v-model="header.IsAdmin"
                      :disabled="!canEdit || this.isAdmin != 'Y'"
                      v-if="header"
                      :binary="true"
                    />
                  </FormField>

                  <FormField
                    :labelName="$t('is_outoffice')"
                    fieldName="IsOutOffice"
                    v-model="header"
                    labelClass="col-4"
                    fieldClass="col-6 md-6"
                    v-if="this.isAdmin == 'Y'"
                  >
                    <!-- <InputText name="Email" v-model="header.Email" type="text" :placeholder="$t('email')"  v-if="header" :disabled="mode == this.$FORM_MODE_VIEW"  /> -->
                    <YNCheckbox
                      v-model="header.IsOutOffice"
                      :disabled="!canEdit || this.isAdmin != 'Y'"
                      v-if="header"
                      :binary="true"
                    />
                  </FormField>

                  <FormField
                    :labelName="$t('receive_notification')"
                    fieldName="ReceiveNotification"
                    v-model="header"
                    labelClass="col-4"
                    fieldClass="col-6 md-6"
                    v-if="this.isAdmin == 'Y'"
                  >
                    <!-- <InputText name="Email" v-model="header.Email" type="text" :placeholder="$t('email')"  v-if="header" :disabled="mode == this.$FORM_MODE_VIEW"  /> -->
                    <YNCheckbox
                      v-model="header.ReceiveNotification"
                      :disabled="!canEdit || this.isAdmin != 'Y'"
                      v-if="header"
                      :binary="true"
                    />
                  </FormField>

                  <FormField
                    v-if="mode != this.$FORM_MODE_CREATE || this.isAdmin == 'Y'"
                    :labelName="$t('password')"
                    fieldName="UseAD"
                    v-model="header"
                    labelClass="col-4"
                    fieldClass="col-6 md-6"
                  >
                    <!-- <InputText name="Email" v-model="header.Email" type="text" :placeholder="$t('email')"  v-if="header" :disabled="mode == this.$FORM_MODE_VIEW"  /> -->
                    <!-- <InputText type="password" v-model="header.Password" :disabled="!canEdit" v-if="header && header.Use_AD"/> -->
                    <Button
                      label="Reset Password"
                      class="p-button-success"
                      :disabled="!canEdit"
                      v-if="header && header.UseAD != 'Y'"
                      @click="confirmResetPass($event)"
                    />
                    <ConfirmPopup></ConfirmPopup>
                  </FormField>

                  <FormField
                    :labelName="$t('isactive')"
                    fieldName="IsActive"
                    v-model="header"
                    labelClass="col-4"
                    fieldClass="col-6 md-6"
                    v-if="mode != this.$FORM_MODE_CREATE"
                  >
                    <YNCheckbox
                      v-model="header.IsActive"
                      :disabled="!canEdit"
                      v-if="header"
                      :binary="true"
                    />
                  </FormField>
                </div>
                <div class="col-6">
                  <Groups
                    :dataArray="header.Groups"
                    :dataModel="groupModel"
                    :mode="mode"
                    v-if="header"
                    :header="header"
                  />
                </div>
              </div>
            </TabPanel>
            <TabPanel
              header="Set Privilege"
              v-if="header && header.IsPriv == 'Y'"
            >
              <Privilege
                :dataArray="header.Privileges"
                :dataModel="privilegeModel"
                :mode="mode"
                v-if="header"
                :header="header"
              />
            </TabPanel>
          </TabView>
        </div>
      </template>
    </Card>

    <!-- <ChangePassword
            v-if="changePassword"
            :isVisible="changePassword"
            :userId="username"
            :requireCurrentPassword="true"
            @hide="hideChangePasswordDialog"
        /> -->

    <Dialog
      header="Lock/Unlock Account"
      v-model:visible="displayDialog"
      :closable="false"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '30vw' }"
    >
      <div>
        <Message severity="warn" :closable="false">
          {{ inactive_msg }} ({{ Is_Locked ? "Locked" : "Unlocked" }})
        </Message>
        <h6 id="single">Please select lock or unlock account</h6>
        <SelectButton
          v-model="Is_Locked"
          :options="lockOption"
          optionLabel="name"
          optionValue="value"
          aria-labelledby="single"
        />
      </div>
      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          @click="closeDialog"
          class="p-button-text"
        />
        <Button label="Save" icon="pi pi-check" @click="saveLockUser" />
      </template>
    </Dialog>
  </form>

  <Dialog
    header="Outstanding Approval"
    v-model:visible="isHaveOsApproval"
    :closeOnEscape="true"
    :closable="true"
    :modal="true"
    :breakpoints="{ '960px': '75vw', '640px': '100vw' }"
    :style="{ width: '60vw' }"
  >
    <span v-show="errMessage" class="p-error">{{ errMessage }}</span>
    <DataTable
      :loading="!dataApprovalOS"
      :value="dataApprovalOS ? dataApprovalOS : null"
      responsiveLayout="scroll"
      class="p-datatable-sm editable-cells-table"
      :rowClass="setCurrentRow"
    >
      <Column
        field="username"
        :header="$t('username')"
        key="username"
        style="width: 10%"
      />
      <Column field="role" :header="$t('role')" key="role" style="width: 10%">
      </Column>
      <Column
        field="status"
        :header="$t('status')"
        key="status"
        style="width: 10%"
      >
      </Column>
      <Column
        field="level"
        :header="$t('level')"
        key="level"
        style="width: 10%"
      >
      </Column>
      <Column
        field="category"
        :header="$t('category')"
        key="category"
        style="width: 10%"
      >
      </Column>
      <Column field="mode" :header="$t('mode')" key="mode" style="width: 10%">
      </Column>
      <Column
        field="company"
        :header="$t('company')"
        key="company"
        style="width: 10%"
      >
      </Column>
      <Column
        field="refno"
        :header="$t('ref_no')"
        key="refno"
        style="width: 10%"
      >
      </Column>
    </DataTable>
  </Dialog>
</template>

<script>
import Privilege from "./_Privilege.vue";
import Groups from "./_Groups.vue";
import Companies from "./_Companies.vue";
import Department from "./_Departments.vue";

//import Locations from './_Locations.vue';

export default {
  name: "Editor",
  components: {
    Groups: Groups,
    Companies: Companies,
    Department: Department,
    Privilege: Privilege,
    //  Locations: Locations
  },
  data() {
    return {
      indexName: "UserIndex",
      url: this.$API_URL + "user/",
      resetPassUrl: this.$API_URL + "user/reset_password",
      header: null,
      detail: null,
      mode: "",
      id: 0,
      formEditable: true,
      groupModel: null,
      companyModel: null,
      businessSegmentModel: null,
      purchaseOrganizationModel: null,
      salesOrganizationModel: null,
      plantModel: null,
      distributionModel: null,
      locationModel: null,
      privilegeModel: null,
      commodityGroupModel: null,
      changePassword: false,
      deparmentmodel: null,
      username: null,
      isAdmin: this.$store.getters.getIsAdmin,
      Is_Locked: null,
      lockOption: [
        { name: "Lock", value: true },
        { name: "Unlock", value: false },
      ],
      displayDialog: false,
      inactive_msg: "",
      filterDept: "",
      showInitPriv: false,
      dataApprovalOS: null,
      isHaveOsApproval: false,
    };
  },
  methods: {
    getData() {
      var self = this;
      this.$axios
        .get(this.url + this.id + "/" + this.mode)
        .then((response) => {
          self.header = response.data.data.header;
          self.groupModel = response.data.data.group;
          self.privilegeModel = response.data.data.privilege;
          self.companyModel = response.data.data.company;
          self.businessSegmentModel = response.data.data.business_segment;
          self.plantModel = response.data.data.plant;
          self.distributionModel = response.data.data.distribution;
          self.locationModel = response.data.data.location;
          self.commodityGroupModel = response.data.data.commodity_group;
          self.purchaseOrganizationModel =
            response.data.data.purchase_organization;
          self.salesOrganizationModel = response.data.data.sales_organization;
          self.Is_Locked = response.data.data.header.Is_Blocked;
          self.deparmentmodel = response.data.data.department;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    changeDept(e) {
      if (e == null) {
        this.header.CompanyCode = "";
        this.header.DepartmentId = "";
      } else {
        this.header.CompanyCode = e.id;
        this.header.DepartmentId = "";
      }
    },
    saveData() {
      var self = this;
      this.$emit("blockBody");
      this.header.mode = this.mode;

      this.$axios
        .post(this.url, this.header)
        .then((response) => {
          if (response.data.success) {
            self.$emit("unblockBody");
            self.$router.push({
              name: this.indexName,
              params: {
                showToast: true,
                severity: "success",
                summary: "Data Saved",
                detail: response.data.message,
                life: 3000,
              },
            });
          } else {
            if (response.data.message_code == "HAVE_OS_APPROVAL") {
              self.dataApprovalOS = response.data.data;
              self.isHaveOsApproval = true;
              self.errMessage = response.data.message;
            }

            self.$emit("unblockBody");
            self.$toast.add({
              severity: "error",
              summary: "Error Saving Data",
              detail: response.data.message,
              life: 3000,
            });
          }
        })
        .catch(function (error) {
          self.$toast.add({
            severity: "error",
            summary: "Error Saving Data",
            detail: error,
            life: 3000,
          });
          self.$emit("unblockBody");
        });
    },
    saveLockUser() {
      var self = this;
      var data = {
        user_id: this.header.Id,
        is_locked: this.Is_Locked,
      };

      this.$emit("blockBody");
      this.$axios
        .post(this.$API_URL + "util/user_lock_unlock/", data)
        .then((response) => {
          self.getData();
          self.$emit("unblockBody");
          self.closeDialog();
          if (response.data.success) {
            self.$toast.add({
              severity: "success",
              summary: "Success Saving Data",
              detail: "User account has been saved successfully.",
              life: 50000,
            });
          } else {
            self.$toast.add({
              severity: "error",
              summary: "Error Saving Data",
              detail: error,
              life: 5000,
            });
          }
        })
        .catch(function (error) {
          self.$toast.add({
            severity: "error",
            summary: "Error Saving Data",
            detail: error,
            life: 5000,
          });
          self.$emit("unblockBody");
        });
    },
    resetPassword() {
      var self = this;
      this.$emit("blockBody");
      this.header.mode = this.mode;

      this.$axios
        .post(this.resetPassUrl, this.header)
        .then((response) => {
          if (response.data.success) {
            // self.$router.push({ name: this.indexName, params: { showToast: true, severity: 'success', summary: 'Password Reset', detail: response.data.message, life: 3000} } );
            self.$toast.add({
              severity: "success",
              summary: "Password Reset",
              detail: response.data.message,
              life: 3000,
            });

            // self.changePassword = true;
            // this.username = this.header.Employee_Number;

            self.$emit("unblockBody");
          } else {
            self.$emit("unblockBody");
            self.$toast.add({
              severity: "error",
              summary: "Error Saving Data",
              detail: response.data.message,
              life: 3000,
            });
          }
        })
        .catch(function (error) {
          self.$toast.add({
            severity: "error",
            summary: "Error Saving Data",
            detail: error,
            life: 3000,
          });
          self.$emit("unblockBody");
        });
    },
    // hideChangePasswordDialog(event){
    //     self = this;
    //     self.changePassword = false;
    //     // this.errormessage = "";

    //     if(event && event.success){
    //         // this.changePasswordSuccess = event.message;
    //         self.$toast.add({ severity: 'success', summary: 'Password Change', detail: event.message, life: 3000 });
    //     }
    // },
    backToIndex() {
      this.$router.push({ path: "/User/Index" });
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    confirm(event) {
      this.$confirm.require({
        target: event.currentTarget,
        message: "Are you sure?",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          this.saveData();
        },
        reject: () => {
          //callback to execute when user rejects the action
        },
      });
    },
    confirmResetPass(event) {
      this.$confirm.require({
        target: event.currentTarget,
        message: "Are you sure?",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          this.resetPassword();
        },
        reject: () => {
          //callback to execute when user rejects the action
        },
      });
    },
    checkdept(event) {
      if (!this.header.DepartmentId) {
        this.showInitPriv = false;
        this.header.IsPriv = false;
        this.$toast.add({
          severity: "error",
          summary: "Error Init Privilege",
          detail: "Please Select Department Before",
          life: 3000,
        });
        return false;
      } else {
        this.showInitPriv = true;
      }
    },
    deptchange(event, e) {
      if (this.dataArray && this.dataArray.length > 0) {
        this.dataArray[event.index].DepartmentId = e == null ? "" : e.id;
      }
    },
    hideRow(data) {
      return data.mode == this.$FORM_MODE_DELETE ? "row-hidden" : null;
    },
    openDialog() {
      this.inactiveMsg();
      this.displayDialog = true;
    },
    closeDialog() {
      this.displayDialog = false;
      this.Is_Locked = this.header.Is_Blocked;
    },
    inactiveMsg() {
      var userAccount = this.header;
      var lastAccessDate = new Date(
        this.$moment(userAccount.Last_Access_Date).format("L")
      );
      var currentDate = new Date(this.$moment(new Date()).format("L"));

      var lastDuration = currentDate.getTime() - lastAccessDate.getTime();
      var totalDays = lastDuration / (1000 * 3600 * 24);

      if (isNaN(totalDays)) {
        this.inactive_msg = "This account has never been active. ";
      } else {
        this.inactive_msg =
          "This account has been inactive for " + totalDays + " days. ";
      }
    },
    onBlur() {
      this.$axios
        .get(this.url + this.header.Username)
        .then((response) => {
          if (response.data.message != "TRUE") {
            this.header.UseAD = "N";
            this.header.Email = "";
          } else {
            this.header.Fullname = response.data.data.text;
            this.header.Email = response.data.data.email;
            this.header.UseAD = "Y";
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },
  },
  created() {
    this.mode = this.$route.query.mode;
    this.id = this.$route.query.id ?? 0;

    this.getData();
  },
  computed: {
    canEdit() {
      return (
        this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT
      );
    },
    canSave() {
      return this.mode != this.$FORM_MODE_VIEW;
    },
    isOverNotAccess() {
      var duration = 90;
      var userAccount = this.header;
      var lastAccessDate = new Date(
        this.$moment(userAccount.Last_Access_Date).format("L")
      );
      var currentDate = new Date(this.$moment(new Date()).format("L"));

      if (userAccount.Last_Access_Date == null) {
        return true;
      } else {
        var lastDuration = currentDate.getTime() - lastAccessDate.getTime();
        var totalDays = lastDuration / (1000 * 3600 * 24);

        if (totalDays >= duration) {
          return true;
        }

        return false;
      }
    },
  },
};
</script>
